import React, { useRef } from "react";
import { useParams } from "react-router-dom";
import { useProductData } from "../../../hooks/useProductData";
import ProductDescription from "./ProductDescription";
import RequestInfo from "../RequestInfo";

const ProductInfo = ({ ProductDataSets }) => {
  const { id, category, subcat } = useParams();
  const { productData, loading } = useProductData();
  const requestInfoRef = useRef(null);

  const JsonProducts = productData?.length ? productData : ProductDataSets;

  const scrollToRequestInfo = () => {
    if (requestInfoRef.current) {
      requestInfoRef.current.scrollIntoView({ behavior: "smooth" });
    } else {
      console.error("RequestInfo ref is not set");
    }
  };

  if (loading) {
    return <div>Loading...</div>;
  } else if (!JsonProducts?.length) {
    return <div>No products found</div>;
  }
  const filtered =
    JsonProducts?.length && JsonProducts.filter((item) => item.id === Number(id));

  return (
    <div className="min-h-screen lg:w-[90%] w-full lg:p-0 p-2 mx-auto flex flex-col sm:gap-10 gap-5 relative py-5">
      {filtered.length &&
        filtered.map((item) => {
          const { image, name, id } = item;
          return (
            <div
              key={id}
              className="flex sm:flex-row flex-col lg:gap-10 sm:gap-5 gap-3 relative sm:items-start items-center"
            >
              <div className="sm:sticky top-[15%] lg:w-[27rem] w-80 lg:h-[28rem] sm:h-96 h-72 flex-shrink-0 max-w-md flex flex-col justify-around">
                <img
                  src={image}
                  alt={name}
                  className=" object-cover w-full max-w-md h-full"
                />
                <button
                  onClick={scrollToRequestInfo}
                  className="border border-lightGray/20 w-full p-2 mt-6 rounded sm:block hidden"
                >
                  Request info
                </button>
              </div>
              <ProductDescription data={item} />
            </div>
          );
        })}
      <RequestInfo
        scrollToRequestInfo={scrollToRequestInfo}
        requestInfoRef={requestInfoRef}
      />
    </div>
  );
};

export default ProductInfo;
